<template>
  <v-container flex grid-list-lg>
    <template v-if="!smartLock">
      <smart-lock-message></smart-lock-message>
    </template>
    <v-layout row wrap v-else>
      <v-flex xs12>
        <v-toolbar color="#eee" class="elevation-0 secondary--text">
          <v-toolbar-title>Faturamentos</v-toolbar-title>
        </v-toolbar>
      </v-flex>
      <v-flex xs4>
        <div class="text-xs-center pt-3">
          <v-date-picker v-model="picker" type="month" locale="pt-br" color="info" style="height: 33em;">
            <v-layout column  style="height: 6em;">
            <v-btn
              block
              flat
              color="green"
              :loading="loading"
              @click="carregarFaturamentos()"
            >CARREGAR FATURAMENTOS</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              block
              flat
              color="green"
              :disabled="data.getDate() !== qtd_dias && this.data.getMonth() + 1 === Number(picker.slice(5))"
              :loading="loading"
              @click="gerarFaturamento"
            >
            Gerar Faturamento
            </v-btn>
            <v-spacer></v-spacer>
            </v-layout>
          </v-date-picker>
        </div>
      </v-flex>
      <v-flex xs8>
        <v-flex xs12 class="mt-2">
          <v-toolbar color="info">
            <v-toolbar-title class="white--text" style="font-size: 1.7em; font-weight: 500;">
              {{!empresas ? 'Faturamento dos postos' : 'Faturamento das empresas'}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom v-if="empresas">
              <v-btn slot="activator" icon dark @click="empresas = false"><v-icon>local_gas_station</v-icon></v-btn>
              Faturamento de Postos
            </v-tooltip>
            <v-tooltip bottom v-else>
              <v-btn slot="activator" icon dark @click="empresas = true"><v-icon>business</v-icon></v-btn>
              Faturamento das empresas
            </v-tooltip>
          </v-toolbar>
        </v-flex>
        <v-layout
          align-center
          justify-center
          class="headline grey--text text--darken-2"
        >
        <v-spacer></v-spacer>
        Selecione um mês para ver os faturamentos
        <v-spacer></v-spacer>
        <v-menu offset-y bottom>
          <v-btn icon slot="activator">
            <v-icon>filter_list</v-icon>
          </v-btn>
          <v-list dense class="pa-0">
            <template v-for="(filtro, index) in filters">
              <v-list-tile :key="index" ripple @click="selected_filter = filtro.value">
                <v-list-tile-content>
                  <v-list-tile-title v-html="filtro.text" class="text-xs-center"></v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-list>
        </v-menu>
        </v-layout>
        <div class="pt-3">
          <v-list>
            <v-list-tile v-if="!faturamentos.length">
              <v-list-tile-content>
                <v-list-tile-title
                  class="text-xs-center title font-weight-light"
                >Sem faturamentos carregados :(</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <template v-else>
              <v-list-tile v-for="(faturamento, index) in faturamentos" :key="index" icon>
                <v-list-tile-avatar icon>
                  <v-icon color="green">
                    {{empresas ? 'business' :'local_gas_station'}}
                  </v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{empresas ? faturamento.empresa ? faturamento.empresa.nome_fantasia : 'Indefinido' : faturamento.posto}}
                  </v-list-tile-title>
                  <v-list-tile-sub-title v-html="`Valor: R$ ${faturamento.valor_faturamento}`"></v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-list-tile-action-text
                    v-html="`Data da Fatura: ${faturamento.data_fatura.split('-').reverse().join('/')}`"
                  ></v-list-tile-action-text>
                  <v-list-tile-action-text
                    v-if="faturamento.fatura_paga"
                    v-html="`Data do Pagamento: ${faturamento.data_hora_pagamento.substr(0, 10).split('-').reverse().join('/')}`"
                  ></v-list-tile-action-text>
                </v-list-tile-action>
                <v-list-tile-action>
                  <v-tooltip lazy bottom>
                    <v-btn icon slot="activator" @click="detalhar(faturamento)">
                      <v-icon color="info">
                        remove_red_eye
                      </v-icon>
                    </v-btn>
                    Detalhes
                  </v-tooltip>
                </v-list-tile-action>
                <v-list-tile-action>
                  <v-tooltip top lazy>
                    <v-btn icon slot="activator" @click="visualizarAnexo(faturamento)">
                      <v-icon color="secondary">receipt</v-icon>
                    </v-btn>Visualizar comprovante
                  </v-tooltip>
                </v-list-tile-action>
                <v-list-tile-action v-if="faturamento.fatura_paga === false">
                  <v-tooltip top lazy>
                    <v-btn icon slot="activator" @click="selecionarFatura(faturamento)">
                      <v-icon color="green">check_circle</v-icon>
                    </v-btn>Confirmar Recebimento
                  </v-tooltip>
                </v-list-tile-action>
                <v-list-tile-action v-else>
                  <v-tooltip top lazy>
                    <v-btn icon slot="activator" @click="selecionarFaturaCancelamento(faturamento)">
                      <v-icon color="red">cancel</v-icon>
                    </v-btn>Cancelar Recebimento
                  </v-tooltip>
                </v-list-tile-action>
              </v-list-tile>
            </template>
          </v-list>
        </div>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog_confirmacao" width="400">
      <v-card>
        <v-card-text
          class="text-xs-center headline primary--text"
        >Confirme o recebimento da fatura para o posto {{
          empresas ? fatura_selecionada.empresa ? fatura_selecionada.empresa.nome_fantasia : 'Indefinido' : fatura_selecionada.posto
        }}</v-card-text>
        <v-card-text class="text-xs-center">
          <v-menu>
            <v-text-field
              slot="activator"
              readonly
              label="Data do Pagamento"
              outline
              hide-details
              :value="selected_date ? selected_date.split('-').reverse().join('/') : ''"
            ></v-text-field>
            <v-date-picker color="info" v-model="selected_date" locale="pt-br"></v-date-picker>
          </v-menu>
        </v-card-text>
        <v-card-actions>
          <v-btn block flat color="grey darken-3" @click="fecharConfirmacao()">VOLTAR</v-btn>
          <v-btn block flat color="green" :disabled="!selected_date" @click="confirmarPagamento()" >CONFIRMAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_cancelamento" width="400">
      <v-card>
        <v-card-text
          class="text-xs-center headline primary--text"
        >Confirme o cancelamento da fatura para o posto {{fatura_cancelamento.posto}}</v-card-text>
        <v-card-actions>
          <v-btn block flat color="grey darken-3" @click="fecharCancelamento()">VOLTAR</v-btn>
          <v-btn block flat color="green" @click="confirmarCancelamento()" >CONFIRMAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="mostrando_detalhes" width="700">
      <detalhes-faturamento :faturaSelecionada="detalhes_fatura" @recarregar="carregarFaturamentos()"></detalhes-faturamento>
    </v-dialog>
    <v-dialog v-if="visualizarComprovante" v-model="visualizarComprovante" width="620">
      <dialog-visualizar :fatura="fatura_selecionada" @fechar="visualizarComprovante = false"/>
    </v-dialog>
    <v-snackbar
      v-model="snackbar.active"
      :color="snackbar.color"
      :multi-line="snackbar.multiLine"
      :timeout="snackbar.timeout"
      :vertical="snackbar.vertical"
    >
      {{ snackbar.text }}
      <v-btn flat @click="snackbar.active = false">Fechar</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>

import DetalhesFaturamento from '@/components/dialogs/DetalhesFaturamento'
import SmartLockMessage from '@/components/SmartLockMessage'
import DialogVisualizar from '@/components/dialogs/DialogVisualizarComprovante'
import moment from 'moment'

export default {
  components: {
    DetalhesFaturamento,
    SmartLockMessage,
    DialogVisualizar
  },
  data () {
    return {
      data: new Date(),
      qtd_dias: 0,
      picker: null,
      dialog_confirmacao: false,
      dialog_cancelamento: false,
      fatura_selecionada: {},
      fatura_cancelamento: {},
      detalhes_fatura: null,
      mostrando_detalhes: false,
      visualizarComprovante: false,
      selected_date: null,
      selected_filter: null,
      empresas: false,
      filters: [
        {
          text: 'Todas',
          value: 'todos'
        },
        {
          text: 'Recebidas',
          value: 'recebidos'
        },
        {
          text: 'Pendentes',
          value: 'pendentes'
        }
      ],
      snackbar: {
        active: false,
        color: '',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        text: ''
      }
    }
  },
  watch: {
    selected_filter (val) {
      if (val && this.picker) {
        this.carregarFaturamentos()
      }
    },
    empresas (val) {
      this.carregarFaturamentos()
    },
    headers (val) {
      if (this.headers) {
        this.carregarFaturamentos()
      }
    }
  },
  computed: {
    headers () {
      return this.$store.getters.headers
    },
    loading () {
      return this.$store.getters.loading
    },
    smartLock () {
      return this.$store.getters.smartLock
    },
    faturamentos () {
      return this.$store.getters.faturamentos
    },
    filtros () {
      let tempFilters = {}
      tempFilters.empresas = this.empresas
      switch (this.selected_filter) {
        case 'recebidos':
          tempFilters['fatura_paga'] = true
          break
        case 'pendentes':
          tempFilters['fatura_paga'] = false
          break
        case 'todos':
          break
        default:
          tempFilters['fatura_paga'] = false
          break
      }
      if (this.picker) {
        tempFilters['data_fatura__month'] = this.picker.split('-')[1]
        tempFilters['data_fatura__year'] = this.picker.split('-')[0]
      }

      return tempFilters
    }
  },
  mounted () {
    this.qtd_dias = new Date(this.data.getFullYear(), this.data.getMonth() + 1, 0).getDate()
    this.selected_filter = 'todos'
    this.picker = moment().format('YYYY-MM-DD HH:mm:ss')
    if (this.headers) {
      this.carregarFaturamentos()
    }
  },
  methods: {
    gerarFaturamento () {
      this.$store.dispatch('gerarFaturamento', {
        mes: this.filtros.data_fatura__month,
        ano: this.filtros.data_fatura__year
      }).then(() => {
        this.showInfo('Seu faturamento está sendo gerado. Aguarde alguns minutos.')
      })
    },
    carregarFaturamentos () {
      this.$store.dispatch('carregarFaturamentos', this.filtros)
    },
    selecionarFatura (fatura) {
      this.fatura_selecionada = fatura
      this.dialog_confirmacao = true
    },
    selecionarFaturaCancelamento (fatura) {
      this.fatura_cancelamento = fatura
      this.dialog_cancelamento = true
    },
    fecharConfirmacao () {
      this.selected_date = null
      this.dialog_confirmacao = false
    },
    fecharCancelamento () {
      this.dialog_cancelamento = false
    },
    confirmarPagamento () {
      this.$store.dispatch('atualizarFaturamento', {
        id: this.fatura_selecionada.id,
        data: {
          fatura_paga: true,
          data_hora_pagamento: `${this.selected_date}T00:00`
        }
      }).then(() => {
        this.fecharConfirmacao()
        this.carregarFaturamentos()
      })
    },
    confirmarCancelamento () {
      this.$store.dispatch('atualizarFaturamento', {
        id: this.fatura_cancelamento.id,
        data: {
          fatura_paga: false,
          data_hora_pagamento: null
        }
      }).then(() => {
        this.fecharCancelamento()
        this.carregarFaturamentos()
      })
    },
    detalhar (fatura) {
      this.detalhes_fatura = fatura
      this.mostrando_detalhes = true
    },
    visualizarAnexo (faturamento) {
      this.fatura_selecionada = faturamento
      this.visualizarComprovante = true
    },
    showInfo (info) {
      this.snackbar.color = 'info'
      this.snackbar.text = info
      this.snackbar.active = true
    }
  }
}
</script>
